export const SET_WIX_DATA = 'SET_WIX_DATA'
export const SET_ITEMS = 'SET_ITEMS'
export const SET_RENDERED_ITEMS_COUNT = 'SET_RENDERED_ITEMS_COUNT'

export const VIDEO_PLAY_MODE = 'VIDEO_PLAY_MODE'
export const GALLERY_WINDOW_LAYOUT_CHANGED = 'GALLERY_WINDOW_LAYOUT_CHANGED'
export const VIDEO_ENDED = 'VIDEO_ENDED'
export const VIDEO_ADDED = 'VIDEO_ADDED'
export const NAVIGATION_IN = 'NAVIGATION_IN'
export const EDITOR_MODE_CHANGED = 'EDITOR_MODE_CHANGED'



// WEBPACK FOOTER //
// ./constants/galleryTypes.js